export const CANDIDATE_KEY_GET_AUDIT_ACCOUNT_TYPE_LIST =
  'CANDIDATE_KEY_GET_AUDIT_ACCOUNT_TYPE_LIST';
export const CANDIDATE_KEY_GET_AUDIT_ROLE_LIST = 'CANDIDATE_KEY_GET_AUDIT_ROLE_LIST';
export const CANDIDATE_KEY_GET_AUDIT_ACTION_LIST = 'CANDIDATE_KEY_GET_AUDIT_ACTION_LIST';
export const CANDIDATE_KEY_POST_ADMIN_AUDIT = 'CANDIDATE_KEY_POST_ADMIN_AUDIT';
export const CANDIDATE_KEY_POST_AUDIT_DOWNLOAD_LINK = 'CANDIDATE_KEY_POST_AUDIT_DOWNLOAD_LINK';
